export class ResourceType {
    static readonly PEOPLE  = 'people'
    static readonly ASSETS  = 'assets'
    static readonly GENERIC = 'generic'

    static readonly DEFAULT = ResourceType.PEOPLE
    static readonly ALLOWED = [
        ResourceType.PEOPLE,
        ResourceType.ASSETS,
        ResourceType.GENERIC,
    ]
}

export type ResourceWorkSchedule = {
    mon? : number
    tue? : number
    wed? : number
    thu? : number
    fri? : number
    sat? : number
    sun? : number
}

// Fixed default icons per type. Values are ItemIconConfig *names*, not CSS
// classes — FieldIcon / FieldFormElement resolve them via ItemIconDict.
// People's row is hidden in the UI; the other two can be changed.
export const RESOURCE_DEFAULT_PEOPLE_ICON  = 'user'
export const RESOURCE_DEFAULT_ASSETS_ICON  = 'tools'
export const RESOURCE_DEFAULT_GENERIC_ICON = 'inventory'

export function resourceDefaultIcon(type: string): string {
    if (type === ResourceType.PEOPLE)  return RESOURCE_DEFAULT_PEOPLE_ICON
    if (type === ResourceType.ASSETS)  return RESOURCE_DEFAULT_ASSETS_ICON
    return RESOURCE_DEFAULT_GENERIC_ICON
}

export function resourceTypeLabel(type: string): string {
    if (type === ResourceType.PEOPLE)  return 'People'
    if (type === ResourceType.ASSETS)  return 'Assets'
    if (type === ResourceType.GENERIC) return 'Generic'
    return type
}
